module.exports = __webpack_public_path__ + "img/16ne.006d191d.svg";